import React from 'react';
import PropTypes from 'prop-types';
import { TableRowColumn } from 'material-ui/Table';
import AutoCompleteData from 'components/list/Filters/types/autocomplete/AutoCompleteData';
import AutoCompleteField from 'components/list/Filters/types/autocomplete/AutoCompleteField';

const AutoCompleteDataInputTableCell = (props) => {
    const {
        name,
        onChangeInput,
        style,
        value,
        searchBy,
        searchParams,
        fullWidth,
        minLength,
        reference,
        optionValue,
    } = props;

    const input = {
        name: name,
        onBlur: (newValue) => {
            if (!newValue.length) {
                const inputEvent = new InputEvent('blur');
                const event = Object.assign({}, inputEvent);

                event.preventDefault = () => {
                    inputEvent.preventDefault();
                };

                event.target = {
                    name: name,
                    id: value.id,
                    value: newValue,
                };

                return onChangeInput(event, newValue, value);
            }
        },
        onChange: (newValue) => {
            if (newValue) {
                const inputEvent = new InputEvent('change');
                const event = Object.assign({}, inputEvent);

                event.preventDefault = () => {
                    inputEvent.preventDefault();
                };

                event.target = {
                    name: name,
                    id: value.id,
                    value: newValue,
                };

                return onChangeInput(event, newValue, value);
            }
        },
        value: value.value || value,
    };

    return (
        <TableRowColumn style={ style }>
            <AutoCompleteData
                input={ input }
                minLength={ minLength }
                reference={ reference }
                searchBy={ searchBy }
                searchParams={ searchParams }
            >
                <AutoCompleteField
                    fullWidth={ fullWidth }
                    input={ input }
                    label={ null }
                    meta={ {
                        touched: false,
                        error: {},
                    } }
                    name={ name }
                    optionText={ searchBy }
                    optionValue={ optionValue }
                />

            </AutoCompleteData>
        </TableRowColumn>
    );
};

AutoCompleteDataInputTableCell.defaultProps = {
    fullWidth: false,
    label: null,
    minLength: 3,
    optionValue: 'id',
    searchBy: 'title',
    searchParams: {
        size: '12',
        sort_by: 'title',
        sort_direction: 'asc',
    },
};

AutoCompleteDataInputTableCell.propTypes = {
    fullWidth: PropTypes.bool,
    minLength: PropTypes.number,
    name: PropTypes.string.isRequired,
    onChangeInput: PropTypes.func.isRequired,
    optionValue: PropTypes.string,
    reference: PropTypes.string.isRequired,
    searchBy: PropTypes.string,
    searchParams: PropTypes.object,
    style: PropTypes.object,
    value: PropTypes.object.isRequired,
};

export default AutoCompleteDataInputTableCell;


// WEBPACK FOOTER //
// ./src/pages/products/configuration/AutoCompleteDataInputTableCell.js